// What the input box shows while the learner records (LAN-584).
//
// The box is read-only for the whole turn. It shows what the learner typed
// before recording, then the live transcript: words the STT worker will not
// revise, then words it may still change (drawn lighter). While the mic is
// live, a blinking caret ends the text; only an empty box shows "Listening…"
// instead. After stop, only an empty box says "Transcribing…"; with text in
// the box, the spinner on the send button says it. The recording indicator
// beside the box is the signal that the mic is on. The
// input's own value is never touched here; the finished transcript reaches it
// once, through applyTranscriptionResult, so a typed draft cannot be
// overwritten.

// state: 'listening' while the mic is live, 'finishing' after stop while the
// result (or the upload fallback) is on its way.
export function liveTranscriptParts({ draft = '', text = '', finalText = '', state = 'listening' }, labels) {
  const parts = [];
  const live = text || '';
  const final = finalText && live.startsWith(finalText) ? finalText : '';
  const provisional = live.slice(final.length);

  if (draft) {
    parts.push({ kind: 'draft', text: live && !/\s$/.test(draft) ? `${draft} ` : draft });
  }
  if (final) parts.push({ kind: 'final', text: final });
  if (provisional) parts.push({ kind: 'provisional', text: provisional });

  const before = `${draft}${live}`;
  if (state === 'finishing') {
    if (!before) parts.push({ kind: 'status', text: labels.finishing });
  } else if (before) {
    parts.push({ kind: 'caret', text: '' });
  } else {
    parts.push({ kind: 'status', text: labels.listening });
  }
  return parts;
}

export function renderLiveTranscript(container, parts) {
  if (!container) return;
  const doc = container.ownerDocument || document;
  const spans = parts.map((part) => {
    const span = doc.createElement('span');
    span.className = `chat-live-${part.kind}`;
    span.textContent = part.text;
    return span;
  });
  container.replaceChildren(...spans);
}
